import { useEffect, useState } from 'react';

export default function ShareBar({ title }: { title: string }) {
  const [toast, setToast] = useState('');

  useEffect(() => {
    if (!toast) return;
    const timer = setTimeout(() => setToast(''), 2000);
    return () => clearTimeout(timer);
  }, [toast]);

  const copyLink = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      setToast('链接已复制，快去分享吧');
    } catch {
      setToast('复制失败，请手动复制地址栏链接');
    }
  };

  const demoShare = (platform: string) => {
    setToast(`${platform}分享为演示功能，暂未接入`);
  };

  return (
    <div className="relative">
      <div className="flex flex-wrap items-center gap-2">
        <button
          type="button"
          onClick={copyLink}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-background-100 text-foreground-800 text-sm font-medium hover:bg-primary-500 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-link"></i>
          复制链接
        </button>
        <button
          type="button"
          onClick={() => demoShare('微信')}
          aria-label="分享到微信"
          className="w-9 h-9 flex items-center justify-center rounded-md bg-background-100 text-foreground-700 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
        >
          <i className="ri-wechat-line"></i>
        </button>
        <button
          type="button"
          onClick={() => demoShare('微博')}
          aria-label="分享到微博"
          className="w-9 h-9 flex items-center justify-center rounded-md bg-background-100 text-foreground-700 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
        >
          <i className="ri-weibo-line"></i>
        </button>
        <button
          type="button"
          onClick={() => demoShare('更多平台')}
          aria-label="更多分享"
          className="w-9 h-9 flex items-center justify-center rounded-md bg-background-100 text-foreground-700 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
        >
          <i className="ri-share-line"></i>
        </button>
      </div>
      {toast && (
        <div className="absolute left-0 -bottom-11 z-20 px-3 py-2 rounded-md bg-foreground-950 text-background-50 text-xs whitespace-nowrap animate-fade-in">
          <i className="ri-information-line mr-1"></i>
          {toast}
        </div>
      )}
      <span className="sr-only">{title}</span>
    </div>
  );
}